import * as React from 'react';

import { useNavigate } from 'react-router';
import { ReminderPublisher } from '@europrocurement/l2d-domain';

const useConsultReminderPublisher = () => {
    const navigate = useNavigate();

    const consultReminderPublisher = React.useCallback(
        (reminderPublisher: ReminderPublisher) => {
            if (!reminderPublisher?.id) return;

            navigate(`${reminderPublisher.id}`);
        },
        [navigate],
    );

    return {
        consultReminderPublisher,
    };
};

export default useConsultReminderPublisher;
